










































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', required);

@Component({
})
export default class SendRequest extends Vue {
    private errors = [];
    private valid = '';
    private senderName = '';
    private senderLink = '';
    private copySuccess = false;

    private created() {
      this.getLinkRequest();
    }

    private submitLink() {
      this.$http.post(`/api/address/link-request-address`, { name: this.senderName }).then((response: any) => {
        // const elem: HTMLElement = document.getElementById('copy-btn') as HTMLElement;
        // elem.click();
      }, (err: any) => {
        // error case
      });
    }

    private getLinkRequest() {
      const linkOrigin = window.location.origin;
      this.$http.post(`/api/address/link-request-address`).then((response: any) => {
        this.senderName = response.data.name;
        this.senderLink = `${linkOrigin}/delivery-request/${response.data.refCode}`;
      }, (err: any) => {
        // error case
      });
    }

    private onCopy() {
      this.copySuccess = true;
    }
    private onCopyError() {
      // copy error case
    }
}
